<script setup lang="ts">
import {
  usePaginationHandlers,
  usePaginationInstance,
} from '@/composable/usePagination';

const pagination = usePaginationInstance();
const paginationHandlers = usePaginationHandlers();
</script>

<template>
  <div
    :ref="paginationHandlers.setScrollRef"
    :class="`layout layout--${pagination.screenType}`"
  >
    <div
      v-if="
        pagination.isOnPaginationRange && pagination.screenType === 'desktop'
      "
      class="layout__navigation--left"
    >
      <slot name="navigation-left" />
    </div>

    <div class="layout__toolbar">
      <slot name="toolbar" />
    </div>

    <div class="layout__body">
      <div class="layout__design-container">
        <slot />
      </div>
    </div>

    <div
      v-if="
        pagination.isOnPaginationRange && pagination.screenType === 'desktop'
      "
      class="layout__navigation--right"
    >
      <slot name="navigation-right" />
    </div>

    <div
      v-if="
        pagination.isOnPaginationRange && pagination.screenType === 'mobile'
      "
      class="layout__navigation"
    >
      <slot name="navigation-left" />
      <slot name="navigation-right" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.layout {
  @apply flex flex-col w-full h-full;
  @apply overflow-hidden;

  &--desktop {
    .layout {
      &__navigation--left,
      &__navigation--right {
        @apply fixed inset-y-0 my-auto h-[max-content] px-4 z-10;
      }

      &__navigation--left {
        @apply left-0;
      }

      &__navigation--right {
        @apply right-0;
      }
    }
  }

  &--mobile {
    .layout {
      &__design-container {
        @apply w-full h-full;
      }

      &__body {
        @apply pt-5 pb-36;
      }

      &__navigation {
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.8) 53.41%,
          #ffffff 100%
        );
        @apply min-h-[88px] w-full inset-x-0 sticky;
      }
    }
  }

  &__body {
    @apply grow w-full;
    @apply h-[calc(100vh-56px)] pt-6 pb-12;
  }

  &__design-container {
    @apply h-full;
  }

  &__navigation {
    @apply flex justify-end items-end gap-1 shrink-0;
    @apply p-3 fixed left-0 bottom-0;
  }
}
</style>
